let initialState = {
    memberships : [],
};

const membershipReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_MEMBERSHIPS" : 
      return {
        ...state,
        memberships : action.payload
      }   
    default : return state
  }

}

export { membershipReducer }
